export const pillars = ['Progress Notes', 'Treatment Plans', 'Interventions', 'Handouts', 'Practice Admin', 'Self-Care'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  short: 'Progress Notes & Documentation',
  title: 'Progress Notes & Session Documentation (The After-Session Pack)',
  desc: '20 prompts for SOAP, DAP, BIRP and GIRP notes, intake summaries, telehealth, couples and group notes, discharge summaries and a final note quality check.'
}, {
  n: 2,
  emoji: '📗',
  short: 'Treatment Plans & Goals',
  title: 'Treatment Plans & Measurable Goals (The Treatment Planning Pack)',
  desc: '20 prompts for problem-goal-objective plans, SMART objectives, plans by presenting concern, plan reviews, progress summaries and discharge criteria.'
}, {
  n: 3,
  emoji: '📙',
  short: 'Session Prep & Interventions',
  title: 'Session Prep & Evidence-Based Interventions (The Session Toolkit)',
  desc: '20 prompts for session agendas, CBT, DBT, ACT, motivational interviewing, solution-focused and narrative tools, role-plays and case conceptualization.'
}, {
  n: 4,
  emoji: '📒',
  short: 'Handouts & Homework',
  title: 'Client Handouts, Homework & Psychoeducation (The Client Resources Pack)',
  desc: '20 prompts for one-page handouts, worksheets, homework, coping cards, trackers, plain-language explainers and kid-friendly versions.'
}, {
  n: 5,
  emoji: '📕',
  short: 'Practice Admin & Communication',
  title: 'Practice Admin & Professional Communication (The Practice Admin Pack)',
  desc: '20 prompts for inquiry replies, consultation calls, policies, letters to providers, billing conversations, reminders and your practice profile.'
}, {
  n: 6,
  emoji: '📔',
  short: 'Supervision, CEUs & Self-Care',
  title: 'Supervision, CEUs, Career & Self-Care (The Clinician Growth Pack)',
  desc: '20 prompts for supervision prep, ethics dilemmas, licensure exam and CEU study, practice growth, boundaries and burnout prevention.'
}];
export const volumeIncludes = ['Complete copy-and-paste prompts (not descriptions)', 'Fill-in-the-blank [brackets] for your own clinical facts', 'A "Use it when" line and a pro tip for every prompt', 'De-identified by design: no names or identifiers needed'];
export const bonuses = [{
  n: '01',
  image: 'https://cdn.magicpatterns.com/uploads/vjMYQPuLPb58QrEM9SnBUo/Guia_rapida_de_IA_para_terapeutas.webp',
  title: 'The 1,000+ Progress Note Phrase Bank™',
  desc: 'Clinical phrases for affect, behavior, interventions, client response and progress, organized by note section.'
}, {
  n: '02',
  image: 'https://cdn.magicpatterns.com/uploads/wo434vPq7uxhUBLVC6cKjW/Guia_rapida_de_IA_para_terapeutas_(1).webp',
  title: 'The Intake & Assessment Question Library™',
  desc: 'Ready-to-use questions for intakes, biopsychosocial history and follow-up sessions, grouped by area.'
}, {
  n: '03',
  image: 'https://cdn.magicpatterns.com/uploads/5AQRmWkjKirr1g74e6NBfT/Guia_rapida_de_IA_para_terapeutas_(2).webp',
  title: 'The Session Opening & Closing Scripts™',
  desc: 'Warm, structured ways to start, transition and close sessions, including telehealth and first sessions.'
}, {
  n: '04',
  image: 'https://cdn.magicpatterns.com/uploads/iSHPqu4eFqq4Sy7oiE2GJp/Guia_rapida_de_IA_para_terapeutas_(3).webp',
  title: 'The Client-Privacy AI Checklist™',
  desc: 'A step-by-step checklist to de-identify information and use AI tools safely in your practice.'
}];
